import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const GallerySection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const projects = [
    {
      id: 1,
      title: 'Complete Loft Insulation Transformation',
      beforeImage: 'https://static.readdy.ai/image/4e26ad7192bd77d86f80f09d990bed83/8551005af81418475e725bd445826d2d.jpeg',
      afterImage: 'https://readdy.ai/api/search-image?query=After%20photo%20of%20professionally%20insulated%20loft%20with%20high-quality%20insulation%20materials%20properly%20installed%20between%20wooden%20beams%2C%20clean%20professional%20installation%2C%20improved%20energy%20efficiency%2C%20warm%20comfortable%20space&width=400&height=300&seq=after1&orientation=landscape',
      description: 'Modern Energy-Efficient Loft Insulation Installation'
    },
    {
      id: 2,
      title: 'Professional Loft Boarding Project',
      beforeImage: 'https://readdy.ai/api/search-image?query=Before%20photo%20of%20loft%20space%20with%20insulation%20but%20no%20boarding%2C%20difficult%20access%2C%20unusable%20storage%20space%2C%20wooden%20joists%20visible%2C%20need%20for%20safe%20boarding%20installation&width=400&height=300&seq=before2&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=After%20photo%20of%20professionally%20boarded%20loft%20space%20with%20safe%20wooden%20boarding%20installed%20over%20insulation%2C%20clean%20accessible%20storage%20area%2C%20proper%20lighting%2C%20organized%20storage%20solution&width=400&height=300&seq=after2&orientation=landscape',
      description: 'Safe Storage Solution with Professional Boarding'
    },
    {
      id: 3,
      title: 'Spray Foam Removal & Replacement',
      beforeImage: 'https://readdy.ai/api/search-image?query=Before%20photo%20of%20problematic%20spray%20foam%20insulation%20in%20loft%20space%2C%20old%20deteriorating%20foam%20insulation%2C%20poor%20condition%20insulation%20needing%20professional%20removal%20and%20replacement&width=400&height=300&seq=before3&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=After%20photo%20of%20clean%20loft%20space%20with%20old%20spray%20foam%20completely%20removed%20and%20replaced%20with%20new%20high-quality%20insulation%20materials%2C%20professional%20clean%20installation%2C%20improved%20energy%20efficiency&width=400&height=300&seq=after3&orientation=landscape',
      description: 'Expert Spray Foam Removal and Modern Insulation'
    },
    {
      id: 4,
      title: 'Energy Efficiency Upgrade',
      beforeImage: 'https://readdy.ai/api/search-image?query=Before%20photo%20of%20poorly%20insulated%20loft%20with%20inadequate%20old%20insulation%20materials%2C%20energy%20inefficient%20attic%20space%2C%20cold%20drafty%20conditions%2C%20need%20for%20professional%20upgrade&width=400&height=300&seq=before4&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=After%20photo%20of%20completely%20upgraded%20loft%20insulation%20with%20premium%20materials%2C%20professional%20installation%2C%20excellent%20energy%20efficiency%2C%20warm%20comfortable%20space%2C%20modern%20insulation%20solution&width=400&height=300&seq=after4&orientation=landscape',
      description: 'Premium Insulation Upgrade for Maximum Efficiency'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % projects.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + projects.length) % projects.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Loft Insulation Before and After Portfolio
          </h2>
          <p className="text-gray-700 max-w-2xl mx-auto mb-8">
            Browse our gallery to see before and after photos of our previous loft insulation projects. Our transformative work speaks for itself.
          </p>
          <Button variant="outline" href="/gallery">
            Browse the Full Gallery
          </Button>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {projects.map((project, index) => (
              <div key={project.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="space-y-4 p-4">
                  <div className="relative">
                    <img 
                      src={project.beforeImage}
                      alt={`${project.title} - Before`}
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                    <div className="absolute bottom-2 left-2 bg-red-600 text-white px-2 py-1 rounded text-sm font-medium">
                      Before
                    </div>
                  </div>
                  <div className="relative">
                    <img 
                      src={project.afterImage}
                      alt={`${project.title} - After`}
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                    <div className="absolute bottom-2 left-2 bg-emerald-600 text-white px-2 py-1 rounded text-sm font-medium">
                      After
                    </div>
                  </div>
                </div>
                <div className="p-4 pt-0">
                  <h3 className="font-bold text-gray-900 mb-2">{project.title}</h3>
                  <p className="text-sm text-gray-600 mb-4">{project.description}</p>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    className="w-full"
                    href={`/projects/${project.id}`}
                  >
                    View Project Details
                  </Button>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button 
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <i className="ri-arrow-left-line text-xl text-gray-700"></i>
          </button>
          <button 
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <i className="ri-arrow-right-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>
    </section>
  );
};
